import Dots from "../Dots/Dots";
import styles from "./GradeCard.module.css";

function GradeCard({ subject, grade, maxGrade }) {
	return (
		<div className={styles.card}>
			<div className={styles.subject}>
				{subject}
			</div>
            <div>
                <Dots type={subject} value={grade} maxValue={maxGrade} />
            </div>
		</div>
	);
}

export default GradeCard;
